/**
 * Hook point before S3 upload / compression in the app layer.
 * TODO: optional auto-crop to bbox, EXIF strip, ICC normalize, etc.
 *
 * @param {File} file
 * @returns {Promise<File>}
 */
export async function prepareFabricCaptureFile(file) {
  return file;
}
